import { useEffect } from 'react'
import styles from './style.module.css'

const APIErrorComponent = ({ error }) => {
    const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        (typeof error === 'string' ? error : 'An unexpected error occurred')
    const isForbidden = error?.response?.status === 422 // Check for 422 error
    useEffect(() => {
        if (error) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, [error])

    if (!error) return null

    return (
        <div className={styles.errorContainer}>
            {!isForbidden && ( // Hide this block if it's a 422 error
                <div className="mb-3">
                    <h2
                        className={`${styles.errorMessage} ${styles.errorHeading}`}
                    >
                        {errorMessage}
                    </h2>
                    {error?.message && error?.message !== errorMessage && (
                        <p className={styles.errorMessage}>{error?.message}</p>
                    )}
                </div>
            )}
            {error?.response?.data?.errors && (
                <div>
                    <ul className={styles.errorList}>
                        {Object.keys(error?.response?.data?.errors)?.map(
                            (field, index) => (
                                <li key={index}>
                                    {error?.response?.data?.errors?.[field]}
                                </li>
                            )
                        )}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default APIErrorComponent
